<div [ngClass]="props.fieldClass" class="d-flex align-items-top">
  <fa-icon *ngIf="props.arrowRight" [icon]="['fas', 'arrow-right']" class="pr-1 mt-2 pt-1" />
  <ng-template #fieldComponent></ng-template>
</div>
